import React from 'react';
import brandConfig from '../../config/brandConfig';
import { ArrowRight, Home, Shield, Zap } from 'lucide-react';

const CallToAction = () => {
  const dashboardUrl = brandConfig.dashboardUrl;

  return (
    <div className="relative py-24 lg:py-32 overflow-hidden grain-overlay" style={{
      background: 'linear-gradient(135deg, #102a43 0%, #1a3a5c 50%, #102a43 100%)'
    }}>
      {/* Decorative elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-40 -left-40 w-[500px] h-[500px] rounded-full opacity-[0.06]" style={{
          background: `radial-gradient(circle, ${brandConfig.primaryColor} 0%, transparent 70%)`
        }} />
        <div className="absolute -bottom-40 -right-40 w-[600px] h-[600px] rounded-full opacity-[0.04]" style={{
          background: `radial-gradient(circle, ${brandConfig.secondaryColor} 0%, transparent 70%)`
        }} />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-4xl lg:text-6xl font-extrabold text-white mb-6 tracking-tight">
            Listo para encontrar
            <span className="block font-display italic mt-2" style={{ color: brandConfig.secondaryColor }}>tu lote ideal?</span>
          </h2>
          <p className="text-lg text-white/50 mb-12 max-w-3xl mx-auto leading-relaxed">
            Unete a miles de personas que ya encontraron su propiedad perfecta
            con {brandConfig.domain}. Comienza tu busqueda hoy mismo.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-16">
            <button className="group flex items-center gap-3 px-8 py-4 rounded-2xl font-bold text-lg text-gray-900 transition-all duration-300 shadow-xl hover:shadow-2xl hover:scale-[1.03]" style={{ background: `linear-gradient(135deg, ${brandConfig.secondaryColor} 0%, #ffd700 100%)` }}>
              <Home className="w-5 h-5" />
              Buscar Lotes
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </button>
            <a
              href={`${dashboardUrl}/iniciar-sesion`}
              className="group flex items-center gap-3 px-8 py-4 rounded-2xl font-bold text-lg text-white transition-all duration-300 glass hover:bg-white/15"
            >
              <img
                src="/images/android-chrome-192x192.png"
                alt={brandConfig.getLogoAlt()}
                width={20}
                height={20}
                className="rounded"
              />
              Soy Inmobiliaria
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </a>
          </div>

          {/* Trust Indicators */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-3xl mx-auto">
            {[
              { icon: <Shield className="w-5 h-5" />, title: '100% Gratis', subtitle: 'Para compradores' },
              { icon: <Shield className="w-5 h-5" />, title: 'Seguro y Confiable', subtitle: 'Proceso verificado' },
              { icon: <Zap className="w-5 h-5" />, title: 'Respuesta Rapida', subtitle: 'En menos de 24h' }
            ].map((item, i) => (
              <div key={i} className="glass rounded-2xl p-5 text-center">
                <div className="inline-flex items-center justify-center w-10 h-10 rounded-xl bg-white/10 mb-3 text-white/70">
                  {item.icon}
                </div>
                <div className="text-white/80 font-semibold text-sm">{item.title}</div>
                <div className="text-white/40 text-xs">{item.subtitle}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CallToAction;
